var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon icon-close",attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}},[_c('path',{attrs:{"fill":"none","stroke":"currentcolor","stroke-width":"2","d":"m.9.9 18.2 18.2M.9 19.1 19.1.9"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }